"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Progress } from "@/components/ui/progress";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  quote: "Mobileo softver nam pomaže pratiti svakodnevne aktivnosti naših čuvara u stvarnom vremenu i imati potpunu kontrolu nad sigurnosnim operacijama. Radi kao sat 24/7.",
  name: "Ricky Brantley",
  role: "Predsjednik, Viking Defense, USA",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/klijent_ricky.png"
}, {
  quote: "Izvrsna platforma koja je digitalizirala naše poslovanje. Transparentnost koju pružamo klijentima putem web portala postala je naša najveća konkurentska prednost.",
  name: "Marko Horvat",
  role: "Direktor Operacija, Sigurnost Plus",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/klijent_marko.png"
}, {
  quote: "Smanjili smo vrijeme administracije za 40%. Podrška je brza i profesionalna, a sustav je izuzetno jednostavan za korištenje čak i za nove zaposlenike.",
  name: "Ana Kovač",
  role: "Voditeljica tima, ProGuard",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/klijent_ana.png"
}];
const AUTOPLAY_DELAY = 6000;
const UPDATE_INTERVAL = 50;
export default function EcosDelPublico() {
  const [api, setApi] = useState<CarouselApi>();
  const [progress, setProgress] = useState(0);
  const [isInteracting, setIsInteracting] = useState(false);
  useEffect(() => {
    if (!api || isInteracting) return;
    const step = UPDATE_INTERVAL / AUTOPLAY_DELAY * 100;
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          api.scrollNext();
          return 0;
        }
        return prev + step;
      });
    }, UPDATE_INTERVAL);
    return () => clearInterval(interval);
  }, [api, isInteracting]);
  useEffect(() => {
    if (!api) return;
    const onSelect = () => {
      setProgress(0);
    };
    const onPointerDown = () => setIsInteracting(true);
    const onPointerUp = () => setIsInteracting(false);
    api.on("select", onSelect);
    api.on("pointerDown", onPointerDown);
    api.on("pointerUp", onPointerUp);
    return () => {
      api.off("select", onSelect);
      api.off("pointerDown", onPointerDown);
      api.off("pointerUp", onPointerUp);
    };
  }, [api]);
  return <section data-section-id="232950" id="iskustva-naših-klijenata" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-primary/5 rounded-lg blur-[120px] mix-blend-multiply animate-pulse" style={{
        animationDuration: '8s'
      }} />
        <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] bg-muted/20 rounded-lg blur-[150px] mix-blend-multiply animate-pulse" style={{
        animationDuration: '12s'
      }} />
        <div className="absolute top-[40%] left-[60%] w-[30%] h-[30%] bg-primary/5 rounded-lg blur-[100px] mix-blend-multiply animate-pulse" style={{
        animationDuration: '10s'
      }} />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/mobileo_pattern_bg.png)] bg-cover bg-center opacity-5 blur-3xl mix-blend-overlay" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-6xl">
        <Card className="bg-[#F9F9F9] border-border/50 shadow-md overflow-hidden rounded-xl">
          <CardContent className="p-0">
            <Carousel setApi={setApi} opts={{
            loop: true,
            align: "center"
          }} className="w-full">
              <CarouselContent>
                {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                    <div className="px-6 py-16 md:px-16 md:py-24 flex flex-col items-center text-center gap-10">
                      <Quote className="size-12 md:size-16 text-primary opacity-10 rotate-0" />
                      
                      <p className="font-default italic text-xl md:text-2xl lg:text-3xl leading-relaxed text-muted-foreground max-w-4xl">
                        "{testimonial.quote}"
                      </p>
                      
                      <div className="flex flex-col items-center gap-4 mt-4">
                        <SafeHydrate><Avatar className="size-20 md:size-24 ring-4 ring-primary/10 ring-offset-4 ring-offset-[#F9F9F9] shadow-sm">
                          <AvatarImage src={testimonial.avatar} alt={testimonial.name} className="object-cover" />
                          <AvatarFallback className="font-default text-2xl bg-muted text-primary">
                            {testimonial.name.charAt(0)}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div className="space-y-1">
                          <h4 className="font-default font-bold text-xl tracking-tight text-primary">
                            {testimonial.name}
                          </h4>
                          <p className="font-default text-sm md:text-base text-[#8A8A8A] uppercase tracking-wider">
                            {testimonial.role}
                          </p>
                        </div>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
            </Carousel>
            
            {}
            <div className="px-8 pb-8 md:px-24 md:pb-12">
              <Progress value={progress} className="h-1.5 bg-muted" />
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}